module.exports = "/_next/static/images/icon_bundle_28-e8e02a784e60ee90dbd512374a0e213c.png";